// @flow

import { getValueForPath } from './FilterFunctions.js'

const compare = (values, sorts, index = 0) => {
  const currValue = `${getValueForPath(sorts[index].value, 0, values[0])}`.toString()
  const nextValue = `${getValueForPath(sorts[index].value, 0, values[1])}`.toString()
  let result = 0
  if (!['alwaysOnTop', 'alwaysOnBottom', 'null'].includes(currValue) && !['alwaysOnTop', 'alwaysOnBottom', 'null'].includes(nextValue)) {
    if (sorts[index].desc) {
      result = nextValue.localeCompare(currValue, 'cs', { numeric: true, sensitivity: 'base' })
    } else {
      result = currValue.localeCompare(nextValue, 'cs', { numeric: true, sensitivity: 'base' })
    }
  } else {
    result = 1
    if (currValue === 'alwaysOnTop') {
      result = -1
    } else if (currValue === 'alwaysOnBottom' || currValue === 'null') {
      result = 3
    } else if (nextValue === 'alwaysOnBottom' || nextValue === 'null') {
      result = -1
    }
  }
  index++
  if (result === 0 && sorts.length > index) {
    return compare([values[0], values[1]], sorts, index)
  }
  return result
}

export const filteredDataSort = (array, sorts) => {
  if (!array || array.length === 0) {
    return []
  }
  if (!sorts || sorts.length === 0) {
    return array
  }
  return array.sort((currItem, nextItem) => compare([currItem, nextItem], sorts))
}

export const sortObjectByProps = (source, sortBy) => {
  const result = {}
  const tempArray = []
  Object.keys(source).map(key => {
    tempArray.push([key, source[key]])
  })

  if (tempArray.length > 1) {
    tempArray.sort((a, b) => a[1][sortBy].localeCompare(b[1][sortBy], 'cs', { sensitivity: 'base' }))
    tempArray.map(item => {
      result[item[0]] = item[1]
    })
  }

  return result
}

export const sortObjectArrayByProp = (array: Array<Object>, sortBy: string) :Array<Object> => {
  if (array.length === 0) {
    return []
  }

  return array.sort((a, b) => {
    if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) {
      throw new Error(`Missing 'sortBy' property in sorted object!`)
    }

    return a[sortBy].localeCompare(b[sortBy], 'cs', {
      sensitivity: 'base',
    })
  })
}

export const sortObjectArrayByList = (array: Array<Object>, sortBy: string, sortList: Array<string>): Array<Object> => {
  if (array.length === 0) {
    return []
  }

  return array.sort((a, b) => {
    if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) {
      throw new Error(`Missing 'sortBy' property in sorted object!`)
    }

    const indexOfA = sortList.indexOf(a[sortBy])
    const indexOfB = sortList.indexOf(b[sortBy])

    /* values missing in sortList */
    if (indexOfA === -1 || indexOfB === -1) {
      return 2
    }

    return indexOfA > indexOfB ? 1 : -1
  })
}
